<div class="simulation-modal">
  <header class="simulation-modal__header">
    <h2>{{ title }}</h2>
    <p>Replays a stored GPS track for this Threat Pair. Nothing is sent to real devices.</p>
  </header>

  <div class="simulation-modal__body">
    <label class="simulation-modal__label" for="simulationScenario">Scenario</label>
    <div class="simulation-modal__select-wrap">
      <select id="simulationScenario" class="simulation-modal__select"
        [(ngModel)]="selectedScenarioId" [ngModelOptions]="{ standalone: true }">
        @for (scenario of scenarios; track scenario.id) {
        <option [value]="scenario.id">{{ scenario.label }}</option>
        }
      </select>
    </div>

    <section class="simulation-modal__info" aria-live="polite">
      <h3>{{ selectedScenario.title }}</h3>
      <p class="simulation-modal__summary">{{ selectedScenario.summary }}</p>
      <div class="simulation-modal__columns">
        <div>
          <h4>What you'll see</h4>
          <p>{{ selectedScenario.see }}</p>
        </div>
        <div>
          <h4>Why it matters</h4>
          <p>{{ selectedScenario.why }}</p>
        </div>
      </div>
    </section>

    <button type="button" class="simulation-modal__coordinates-toggle"
      [attr.aria-expanded]="showCustomCoordinates" (click)="showCustomCoordinates = !showCustomCoordinates">
      <span>{{ showCustomCoordinates ? '−' : '+' }}</span> Use custom coordinates
    </button>

    @if (showCustomCoordinates) {
    <section class="simulation-modal__coordinates" aria-label="Custom simulation coordinates">
      <p>Optional runtime override. Enter the full list to replace the selected scenario coordinates.</p>
      <div class="simulation-modal__coordinate-grid">
        <label>
          Survivor
          <textarea [(ngModel)]="survivorCoordinates" [ngModelOptions]="{ standalone: true }"
            placeholder="[[85.3155263, 27.7142794], [85.3155138, 27.71421]]"></textarea>
        </label>
        <label>
          Perpetrator
          <textarea [(ngModel)]="perpetratorCoordinates" [ngModelOptions]="{ standalone: true }"
            placeholder="[[85.3161020, 27.7149012], [85.31611, 27.71485]]"></textarea>
        </label>
      </div>
      @if (coordinateError) {
      <small class="simulation-modal__coordinate-error">{{ coordinateError }}</small>
      }
    </section>
    }
  </div>

  <footer class="simulation-modal__footer">
    <div>
      <button type="button" class="simulation-modal__cancel" (click)="close()">Cancel</button>
      <button type="button" class="simulation-modal__run" (click)="run()">Simulate</button>
    </div>
  </footer>
</div>
